module.exports = __webpack_public_path__ + "img/MRC_IEU_Bristol_White.b1d0ce5f.svg";